export default __webpack_public_path__ + "static/media/3442.03a420d3.png";